const localhost = 'https://localhost.sans.org:8200';

export const API_BASE = (globalThis.window.location.hostname.indexOf('localhost') === 0 ? localhost : '') + '/api';
export const API_CREDENTIALS = 'include';
export const API_REQUEST_TIMEOUT_MS = 30000;
